import ReactDom from 'react-dom'

const MODAL_STYLES = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'transparent',
    zIndex: 1000,
    minWidth: '300px',
}

const OVERLAY_STYLES = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, .7)',
    zIndex: 900
}

export default function Modal({ open, children, onClickOutside, lock = false }) {
    
    if (!open) return null

    return ReactDom.createPortal(
        <>
            <div style={OVERLAY_STYLES} onClick={!lock ? onClickOutside : null} />
            <div style={MODAL_STYLES}>
                {children}
            </div>
        </>,
        document.getElementById('portal')
    )
}